import { styled } from '@mui/material/styles';
import { CardContainer } from '../common/styles';

export const DaySoldCardContainer = styled(CardContainer)(({ theme }) => ({
  border: `3px solid ${theme.palette.primary.main}`,
}));
